export enum UserMenuOptions {
  MoreInfo = 'More Info',
  DisableUser = 'Disable User',
  ArchiveUser = 'Archive User',
}
